import { URL_API } from "../../../general/init/url";

export const API_LABA_RUGI_GET = URL_API + "/api/LabaRugiData";
export const API_LABA_RUGI_GENERATE = URL_API + "/api/LabaRugiData/Generate";
export const API_LABA_RUGI_GET_DOWNLOAD =
  URL_API + "/api/LabaRugiData/Download";
export const API_LABA_RUGI_GET_DOWNLOAD_PDF =
  URL_API + "/api/LabaRugiData/DownloadPDF";
